export const GET_ALL_USER_LIST= "GET_ALL_USER_LIST";
export const GET_ALL_USER_LIST_SUCCESS = "GET_ALL_USER_LIST_SUCCESS"; 
export const SEARCH_USER_ACTIVATION = "SEARCH_USER_ACTIVATION";
export const SEARCH_USER_ACTIVATION_SUCCESSFULL = "SEARCH_USER_ACTIVATION_SUCCESSFULL";
export const SEARCH_ACTIVATION_FAILED = "SEARCH_ACTIVATIOON_FAILED";
